import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const NOOP = () => {};
const getColor = (flavor) => {
  switch (flavor) {
    case 'destroy':
      return 'var(--cc_color_utility_destroy)';
    case 'info':
      return 'var(--cc_color_link_default)';
    case 'success':
      return 'var(--cc_color_utility_success_darken_10)';
    default:
      return 'var(--cc_color_link_default)';
  }
};

const Button = styled.button`
  // Reset default button styles
  width: 100%;
  margin: 0;
  border: 0;
  cursor: pointer;
  appearance: none;
  background: none;
  transition: all cubic-bezier(0.785, 0.135, 0.15, 0.86) 0.2s;
  display: flex;
  align-items: center;
  gap: var(--cc_size_spacing_s);
  padding: var(--cc_size_spacing_s);
  border-radius: var(--cc_size_border_radius_l);
  color: ${(props) => props.color};
  font-weight: 400;
  font-family: 'Averta', system-ui, sans-serif;
  font-size: var(--cc_size_text_s);
  text-align: left;

  i {
    font-size: var(--cc_size_text_m);
    line-height: 1;
  }

  &:hover {
    background: var(--cc_color_button_background_subtle);
  }
`;

/**
 * @deprecated Use { MenuItem } from `@companycam/slab-web` instead
 *
 * https://slab-web.cocam.co/?path=/docs/menu--docs
 */

const DropdownItem = ({
  className,
  children,
  flavor,
  onClick,
  disabled,
  testId,
}) => {
  const color = getColor(flavor);
  return (
    <Button
      color={color}
      type="button"
      className={className}
      onClick={onClick}
      role="menuitem"
      disabled={disabled}
      data-testid={testId}
    >
      {children}
    </Button>
  );
};

DropdownItem.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  flavor: PropTypes.oneOf(['destroy', 'info', 'success']),
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  testId: PropTypes.string,
};

DropdownItem.defaultProps = {
  className: undefined,
  disabled: false,
  flavor: 'info',
  onClick: NOOP,
  testId: null,
};

export default DropdownItem;
